export enum FileType {
    img = 'Фото',
    video = 'Видео'
}

export interface DataElement {
    Id: number;
    PhotoNumber: number;
    FileTypeName?: string;
    FileType: {
        FileExtensionsToString: string;
    };
}

export interface IGallery {
    setData(data: DataElement[]): void;
}

export interface Options {
    baseUrl: string;
    data: DataElement[];
}

export interface GalleryItem {
    src: string;
    type?: string;
    width?: number;
    height?: number;
}
